module.exports = __webpack_public_path__ + "img/1-3.75edd3a3.png";